import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";

// Components
import { ConferenceDescription } from "./ConferenceDescription/ConferenceDescription";
import { ConferenceHeader } from "./ConferenceHeader/ConferenceHeader";
import { ConferenceHighlightVideo } from "./ConferenceHighlightVideo/ConferenceHighlightVideo";
import { ConferenceSessions } from "./ConferenceSessions/ConferenceSessions";
import { ConferenceSpeakers } from "./ConferenceSpeakers/ConferenceSpeakers";
import { ConferenceSponsors } from "./ConferenceSponsors/ConferenceSponsors";
import { ConferenceVideos } from "./ConferenceVideos/ConferenceVideos";
import { ConferenceNews } from "./ConferenceNews/ConferenceNews";
import { ConferencesPrevious } from "../../components/ConferencesPrevious/ConferencesPrevious";
import { LoadingPageContainer as LoadingPage } from "../../components/LoadingPage/LoadingPageContainer";

// Context
import { TagsContext } from "../../context/tags";

// CSS
import styles from "./conference.module.scss";

export const Conference = (props) => {
    const { conference } = props;
    const { title, description, sessions } = conference || {};

    /**
     * Router Hooks
     */

    const history = useHistory();

    /**
     * Context
     */

    const { addTag } = useContext(TagsContext);

    /**
     * Constants
     */

    const hasSessions = sessions && sessions.length;
    const isLoading = !conference;

    /**
     * End Hooks & Constants
     */

    return (
        <div className={styles.conference}>
            <Helmet>
                <title>{conference?.title}</title>
                <meta name="title" content={title} />
                <meta name="description" content={description} />
                <meta name="robots" content="index, follow" />
            </Helmet>
            {isLoading && <LoadingPage {...props} />}
            <ConferenceHeader {...props} />
            <ConferenceDescription {...props} />
            <ConferenceHighlightVideo {...props} />
            {hasSessions && <ConferenceSessions {...props} />}
            <ConferenceVideos {...props} addTag={addTag} />
            <ConferenceNews {...props} history={history} />
            <ConferenceSpeakers {...props} />
            <ConferenceSponsors {...props} />
            <ConferencesPrevious {...props} history={history} />
        </div>
    );
};
